// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"8b1a6da6","445":"8561b089"}[chunkId] + ".chunk.js";
};